import PropTypes from 'prop-types';

export const Props = {
  /**
   * The message displayed in the empty block
   */
  message: PropTypes.string,
  /**
   * For CSS customization
   */
  className: PropTypes.string,
};
